import React from 'react';
import { useStyles } from './style';

const InvisibleCard: React.FC = ({}) => {
    const classes = useStyles();

    return <div className={classes.cardInvisible} />;
};
export default InvisibleCard;
